<template>
  <v-dialog v-model="dialogVisible" max-width="900px" persistent>
    <v-card>
      <!-- En-tête -->
      <!-- <v-card-title class="text-h5 bg-primary text-white pa-4">
        <span>Bon de Transfert d'Articles</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title> -->
        <v-toolbar height="auto" flat class="pa-2">
            <v-toolbar-title class="w-100">
                <v-row align="center" no-gutters>
                <v-col cols="auto">
                    <v-avatar color="primary" size="32" class="mr-3">
                    <v-icon dark size="18">mdi-store</v-icon>
                    </v-avatar>
                </v-col>
                <v-col>
                    <div class="text-subtitle-1 font-weight-bold">
                        Bon de Transfert d'Articles
                    </div>
                    <!-- <div class="text-caption grey--text">
                    Code-barres: {{ props.article.codebarre }}
                    </div> -->
                </v-col>
                <v-col cols="auto">
                    <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                </v-row>
            </v-toolbar-title>
        </v-toolbar>

      <v-card-text class="pa-4">
        <!-- Informations d'en-tête -->
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              v-model="store.state.transfert.etablissementOrigine"
              :items="etablissements"
              item-title="nom"
              item-value="id"
              label="Origine *"
              :rules="[v => !!v || 'Champ requis']"
              required
              variant="outlined"
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="store.state.transfert.etablissementDestinataire"
              :items="etablissements"
              item-title="nom"
              item-value="id"
              label="Destinataire *"
              :rules="[v => !!v || 'Champ requis']"
              required
              variant="outlined"
              density="compact"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="store.state.user.username"
              label="Utilisaleur *"
              :rules="[v => !!v || 'Champ requis']"
              required
              variant="outlined"
              density="compact"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- Lignes du transfert -->
        <div class="d-flex align-center mb-2">
          <span class="text-h6">Articles</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" size="small" @click="ajouterLigne">
            <v-icon left>mdi-plus</v-icon>
            Ajouter une ligne
          </v-btn>
        </div>

        <v-table class="border rounded">
          <thead style="height:10px">
            <tr>
              <th >Article</th>
              <th class="text-center">Prix TTC</th>
              <th class="text-center">Qté</th>
              <th class="text-center">Total</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ligne, index) in store.state.transfert.lignes" :key="index">
              <td>
                <v-chip 
                  density="compact"
                  variant="outlined"
                >{{ ligne.designation }}</v-chip>
              </td>
              
              <td class="text-center">
                <v-chip density="compact" variant="outlined" size="2"  >
                    <input size="2" type="number" v-model.number="ligne.prixTTC" step="0.01" @input="calculerTotalLigne(index)">
                </v-chip>
                
              </td>
              <td class="text-center">
                <v-chip density="compact" variant="outlined"  size="2">
                    <input size="2" type="number" v-model.number="ligne.qte" min="1" step="1" @input="calculerTotalLigne(index)">
                </v-chip>
               
              </td>
              <td class="text-right font-weight-bold">
                {{ formatPrix(ligne.totalLigne) }}
              </td>
              <td class="text-center">
                <v-btn
                  icon
                  size="small"
                  color="error"
                  variant="text"
                  @click="supprimerLigne(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="store.state.transfert.lignes.length === 0">
              <td colspan="7" class="text-center pa-4 text-grey">
                Aucun article ajouté
              </td>
            </tr>
          </tbody>
        </v-table>

        <v-divider class="my-4"></v-divider>

        <!-- Pied de page -->
        <v-row class="mt-2">
          <v-col cols="12" md="6"></v-col>
          <v-col cols="12" md="6">
            <v-card variant="outlined" class="pa-3">
              <v-row>
                <v-col cols="6">
                  <div class="text-subtitle-2 text-grey">Total Qté</div>
                  <div class="text-h6">{{ totalQte }}</div>
                </v-col>
                <v-col cols="6" class="text-center">
                  <div class="text-subtitle-2 text-grey">Total TTC</div>
                  <div class="text-h6 text-primary">{{ formatPrix(totalTTC) }}</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Actions du dialogue -->
      <v-card-actions class="pa-4">
        <v-btn variant="text" @click="closeDialog">Annuler</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="validerTransfert" :disabled="!estValide">
          <v-icon left>mdi-check</v-icon>
          Valider le transfert
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import store from '@/store'
// Props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  article:{
    type: Object
  },
  etablissements: {
    type: Array
  },
  stockEtabOrigine: {
    type : String
  }
})

// Événements
const emit = defineEmits(['update:modelValue', 'validate'])

// Référence du dialogue
const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// Données du transfert
store.state.transfert = {
  etablissementOrigine: props.stockEtabOrigine,
  etablissementDestinataire: store.state.etablissement,
  createur: store.state.user.username,
  lignes: [
    {
        designation: `${props.article.designation} -${props.article.reference_y2} - ${props.article.couleur}${props.article.taille?' - '+props.article.taille:''} - ${props.article.codebarre}`,
        reference: props.article.reference_y2,
        couleur: props.article.couleur,
        taille: props.article.taille,
        codeBarre: props.article.codebarre,
        prixTTC: props.article.vte_euro,
        qte: 1,
        totalLigne: props.article.vte_euro
    }
  ]
}

// Fonctions
const ajouterLigne = () => {
  store.state.transfert.lignes.push({
    designation: `${props.article.designation} -${props.article.reference_y2} - ${props.article.couleur}${props.article.taille?' - '+props.article.taille:''} - ${props.article.codebarre}`,
    reference: props.article.reference_y2,
    couleur: props.article.couleur,
    taille: props.article.taille,
    codeBarre: props.article.codebarre,
    prixTTC: props.article.vte_euro,
    qte: 1,
    totalLigne: props.article.vte_euro
  })
}

const supprimerLigne = (index) => {
  store.state.transfert.lignes.splice(index, 1)
}

const calculerTotalLigne = (index) => {
  const ligne = store.state.transfert.lignes[index]
  ligne.totalLigne = (ligne.prixTTC || 0) * (ligne.qte || 0)
}

const formatPrix = (valeur) => {
  if (valeur === undefined || valeur === null) return '0,00 €'
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(valeur)
}

// Totaux
const totalQte = computed(() => {
  return store.state.transfert.lignes.reduce((acc, ligne) => acc + (ligne.qte || 0), 0)
})

const totalTTC = computed(() => {
  return store.state.transfert.lignes.reduce((acc, ligne) => acc + (ligne.totalLigne || 0), 0)
})

// Validation
const estValide = computed(() => {
  return (
    store.state.transfert.etablissementOrigine &&
    store.state.transfert.etablissementDestinataire &&
    store.state.transfert.createur &&
    store.state.transfert.lignes.length > 0 &&
    store.state.transfert.lignes.every(ligne => ligne.designation && ligne.qte > 0)
  )
})

const validerTransfert = () => {
  if (estValide.value) {
    emit('validate', { ...store.state.transfert })
    closeDialog()
  }
}

const closeDialog = () => {
  dialogVisible.value = false
  // Réinitialiser après fermeture
  setTimeout(() => {
    store.state.transfert = {
      etablissementOrigine: null,
      etablissementDestinataire: null,
      createur: '',
      lignes: []
    }
  }, 300)
}

// Réinitialiser quand le dialogue s'ouvre
// watch(dialogVisible, (nouvelleValeur) => {
//   if (nouvelleValeur) {
//     store.state.transfert.lignes = []
//   }
// })
</script>

<style scoped>
.v-table {
  font-size: 0.85rem;
}

.v-table th {
  background-color: #f5f5f5;
  font-weight: 600;
}

:deep(.v-field--variant-outlined .v-field__input) {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>